// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2wLB5","buttons":"SendReceipts_buttons__BqsWV","email":"SendReceipts_email__2omXu","bookApptTitle":"SendReceipts_bookApptTitle__hah4-"};